export const injectWorkspaceId = ({ href, selectedOfficeId }: { href: string; selectedOfficeId: number }) => {
  return href.replace(':workspaceId', selectedOfficeId.toString());
};
